import React from 'react';
import { useTranslation } from 'react-i18next';
import { getI18nValue } from 'utils/Utils';
import PropTypes from 'prop-types';

const selectClass = "text-sm border border-gray-300 rounded pl-2 pr-7 py-1.5 text-gray-600 bg-white cursor-pointer focus:outline-none focus:ring-1 focus:ring-blue-400";

function ChannelSelect({ value, onChange }) {
    const { t } = useTranslation();

    return (
        <select value={value} onChange={(e) => onChange(e.target.value)} className={selectClass}>
            <option value="">{t(getI18nValue('analytics.kpi.filters', 'all_channels'))}</option>
            <option value="messenger">Messenger</option>
            <option value="whatsapp">WhatsApp</option>
            <option value="web">Web</option>
        </select>
    );
}

ChannelSelect.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

export default ChannelSelect;
